import { Chart, registerables } from "chart.js";
import Bills from "../../components/Bills/Bills";

const BillPage = () => {
  Chart.register(...registerables);
  Chart.defaults.font.family = "Roboto";
  Chart.defaults.font.size = 14;

  return <Bills />;
};

export default BillPage;
